/**
 * Some MUI v4 paths strip `aria-label` off the native form control when it's passed via
 * inputProps (InputBase's cloneElement chain drops it — only `id` and `style` survive).
 * As a last-resort defence for axe's `label` / `select-name` rules we accept a custom
 * `data-a11y-label` attribute (MUI does NOT filter unknown `data-*` attrs) and enforce
 * it onto `aria-label` via a global MutationObserver that runs for the lifetime of the
 * app. Any re-render that clobbers aria-label is immediately reconciled.
 */
let installed = false

function applyLabel(el: Element) {
  const dataLabel = (el as HTMLElement).dataset?.a11yLabel
  if (!dataLabel) return
  if (el.getAttribute('aria-label') !== dataLabel) {
    el.setAttribute('aria-label', dataLabel)
  }
}

function applyAll(root: ParentNode) {
  const nodes = root.querySelectorAll('[data-a11y-label]')
  for (let i = 0; i < nodes.length; i += 1) applyLabel(nodes[i])
}

export function installAriaLabelEnforcer() {
  if (installed || typeof document === 'undefined') return
  installed = true

  const run = () => applyAll(document.body)
  run()

  const observer = new MutationObserver(() => run())
  observer.observe(document.body, { childList: true, subtree: true, attributes: true })
}
